/**
 * Demo UI match rule from numeric score + threshold:
 * - similarity (finger, iris mock): match when score >= threshold
 * - distance (face): match when score <= threshold (lower score = closer match)
 * If either value is not numeric, falls back to server MATCHED / NOT_MATCHED when present.
 */

export function parseOptionalNumber(value) {
  if (value === null || value === undefined || value === '') return undefined;
  const n = typeof value === 'number' ? value : parseFloat(value);
  return Number.isNaN(n) ? undefined : n;
}

function serverMatchToBool(serverMatch) {
  if (serverMatch === true || serverMatch === 'true') return true;
  if (serverMatch === false || serverMatch === 'false') return false;
  const s = String(serverMatch || '').toUpperCase();
  if (s === 'MATCHED') return true;
  if (s === 'NOT_MATCHED' || s === 'NOT MATCHED') return false;
  return null;
}

export function resolveIsMatch(score, threshold, serverMatch, mode = 'similarity') {
  const scoreNum = parseFloat(score);
  const thresholdNum = parseFloat(threshold);
  if (!Number.isNaN(scoreNum) && !Number.isNaN(thresholdNum)) {
    return mode === 'distance' ? scoreNum <= thresholdNum : scoreNum >= thresholdNum;
  }
  const fromServer = serverMatchToBool(serverMatch);
  return fromServer === true;
}
